import { z } from 'zod';

import { schemaApproved } from './discriminatedUnions/approved';
import { schemaCanceled } from './discriminatedUnions/canceled';
import { schemaInitial } from './discriminatedUnions/initial';
import { schemaInProgress } from './discriminatedUnions/inProgress';
import { schemaOfferAtBank } from './discriminatedUnions/offerAtBank';
import { schemaOfferAtCustomer } from './discriminatedUnions/offerAtCustomer';

export const schemaStatus = z.discriminatedUnion('status', [
    schemaInitial,
    schemaInProgress,
    schemaOfferAtCustomer,
    schemaOfferAtBank,
    schemaApproved,
    schemaCanceled,
]);

export type Schema_Status = z.infer<typeof schemaStatus>;
